import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { usePageController } from "../../../store/PageController";

const sidebar_items = {
  backgroundColor: "primary.light",
  color: "primary.dark",
  padding: "10px 24px",
  borderRadius: "100px",
  cursor: "pointer",
};

const sidebar_items_notselected = {
  backgroundColor: "none",
  color: "primary.dark",
  padding: "10px 24px",
  borderRadius: "100px",
  cursor: "pointer",
};

const components = ["intro", "create", "deployments", "docs"];
const Sidebar = () => {
  const { currentComponent, setCurrentComponent } = usePageController();

  function handleClick(component) {
    setCurrentComponent(component);
  }

  return (
    <div className="sidebar-container">
      <Typography
        sx={
          currentComponent === components[0]
            ? sidebar_items
            : sidebar_items_notselected
        }
        onClick={() => handleClick(components[0])}
      >
        Introduction
      </Typography>
      <Typography
        sx={
          currentComponent === components[1]
            ? sidebar_items
            : sidebar_items_notselected
        }
        onClick={() => handleClick(components[1])}
      >
        Create
      </Typography>
      <Typography
        sx={
          currentComponent === components[2]
            ? sidebar_items
            : sidebar_items_notselected
        }
        onClick={() => handleClick(components[2])}
      >
        Deployments
      </Typography>
      <Typography
        sx={
          currentComponent === components[3]
            ? sidebar_items
            : sidebar_items_notselected
        }
        onClick={() => handleClick(components[3])}
      >
        Documentation
      </Typography>
    </div>
  );
};

export default Sidebar;
